import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { QUERY_KEY } from '~common';
import { postRequest } from '~services';
import { ReasonListingRequestParams, ReasonListingResponse } from '~types';

export const getUnpinningReasons = (
  reqParams: ReasonListingRequestParams,
): Promise<ReasonListingResponse> =>
  postRequest({
    path: 'api/unpinning-reason/list',
    data: reqParams,
  }).then((res) => res.data);

export const useQueryGetReason = (
  reqParams: ReasonListingRequestParams,
  options?: Omit<
    UseQueryOptions<
      ReasonListingResponse,
      AxiosError<Record<string, string>>,
      ReasonListingResponse,
      (QUERY_KEY | ReasonListingRequestParams)[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  return useQuery(
    [QUERY_KEY.GET_UNPINNING_REASONS, reqParams],
    () => getUnpinningReasons(reqParams),
    {
      ...options,
    },
  );
};
